var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cloud-bed"},[_c('div',{staticClass:"cloud-box"},_vm._l((_vm.placeList),function(item,index){return _c('span',{key:index,style:({color:item.color,background:item.bgColor}),on:{"click":function($event){return _vm.getDataInfo(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }